import "./ModeSelectionComponent.scss";
import { useIsMobile } from "@/hooks/use-mobile";

interface ModeSelectionComponentProps {
    onModeSelection: (mode: 'text' | 'voice') => void;
}

const ModeSelectionComponent = ({ onModeSelection }: ModeSelectionComponentProps) => {

    const isMobile = useIsMobile();

    return (
        <div className="mode-selection-container">
            <h3 className="mode-selection-title">
                How would you like to communicate?
            </h3>
            <div className="mode-selection-grid">
                {/* Text Only Mode */}
                <button
                    onClick={() => onModeSelection('text')}
                    className="mode-selection-card"
                    
                >
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        stroke="currentColor" 
                        strokeWidth="2" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                        className="mode-selection-icon"
                    >
                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                        <line x1="9" x2="15" y1="10" y2="10"/>
                        <line x1="12" x2="12" y1="7" y2="13"/>
                    </svg>
                    <h4 className="mode-selection-card-title">Text Only</h4>
                    {
                        !isMobile && (
                            <>
                             <p className="mode-selection-card-description">
                        Type your messages to communicate with Zoya
                    </p>
                            </>
                        )
                    }
                   

                    <div className="mode-selection-badge mode-selection-badge-success">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12"/>
                        </svg>
                        No microphone needed
                    </div>
                </button>

                {/* Voice + Text Mode */}
                <button
                    onClick={() => onModeSelection('voice')}
                    className="mode-selection-card mode-selection-card-recommended"
                >
                    <div className="recommended-tag">Recommended</div>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        stroke="currentColor" 
                        strokeWidth="2" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                        className="mode-selection-icon"
                    >
                        <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"/>
                        <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
                        <line x1="12" x2="12" y1="19" y2="22"/>
                    </svg>
                    <h4 className="mode-selection-card-title">Voice + Text</h4>
                    {
                        !isMobile && (
                            <>
                         
                    <p className="mode-selection-card-description">
                        Speak or type for a hands-free experience
                    </p>
                    </>
                        )
                    }
                    <div className="mode-selection-badge mode-selection-badge-warning">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="10"/>
                            <line x1="12" x2="12" y1="8" y2="12"/>
                            <line x1="12" x2="12.01" y1="16" y2="16"/>
                        </svg>
                        Requires microphone access
                    </div>
                </button>
            </div>
        </div>
    );
};

export default ModeSelectionComponent;

